
import Vue from "vue";

import dialogCom from "@/components/ModelCom.vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import Utils from "@/assets/js/Utils";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
export default Vue.extend({
  components: { action, pageCom },
  data() {
    return {
      dialogTableVisible: false,
      total: 0,
      pageSize: 20,
      items: [] as any,
      currentPage: 1,
      currentSid: null as any,
      showImg: false,
      pics: [] as string[],
      sid: null as any,
      typeSid: null as any,
    };
  },
  mounted() {
    this.getTypeSid();
    this.currentSid = Utils.getCurrentSid(this.$route.path);
    this.sid = this.$route.query.sid;
    console.log(this.currentSid);
    if (this.currentSid == "12") {
      this.showImg = true;
    }
    this.getList();
  },
  methods: {
    getTypeSid() {
      const path: any = this.$route.path;
      if (path.toLocaleLowerCase().indexOf("/home/dustcar") != -1) {
        this.typeSid = "c05";
      }
    },
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const array: string[] = [
        "deviceName",
        "addr",
        "serial",
        "deviceTypeName",
        "alarmTypeName",
      ];
      let req: any = await Utils.GetPageReq(
        this.currentPage,
        this.pageSize,
        content,
        array
      );
      if (!req.conditions) {
        req.conditions = [];
      }
      req.conditions.push({
        field: "categorySid",
        value: this.currentSid,
        conditionType: 0,
        andCondition: true,
      });
      if (this.sid) {
        req.conditions.push({
          field: "deviceSid",
          value: this.sid,
          conditionType: 0,
          andCondition: true,
        });
      }
      if (this.typeSid != null) {
        req.conditions.push({
          field: "deviceTypeSid",
          value: this.typeSid,
          conditionType: 0,
          andCondition: true,
        });
      }
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetDeviceAlarms, req, true, false);
      if (ret && ret.data) {
        ret.data.forEach((element: any) => {
          element.alarmTypeSid = null;
          if (element.alarmPics) {
            element.alarmPics = JSON.parse(element.alarmPics);
            // const json: any[] = [];
            // if (json && json.length > 0) {
            //   let picList: any[] = [];
            //   try {
            //     picList = element.alarmPics ? JSON.parse(element.alarmPics) : [];
            //   } catch {
            //     picList = [];
            //   }
            //   if (Array.isArray(picList) && picList.length > 0) {
            //     element.alarmTypeSid = picList[0];
            //     console.log(element.alarmTypeSid, picList, "ttttt");
            //   }
            // }
          }
        });
      }
      this.items = ret.data;
      this.total = ret.total;
      console.log(this.items);
    },

    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getList();
    },
    imgClick(pics: string[]) {
      this.pics = pics;
      this.dialogTableVisible = true;
    },
  },
});
